import { render, staticRenderFns } from "./FileDialog.vue?vue&type=template&id=ff68fa2c&scoped=true&"
import script from "./FileDialog.vue?vue&type=script&lang=js&"
export * from "./FileDialog.vue?vue&type=script&lang=js&"
import style0 from "./FileDialog.vue?vue&type=style&index=0&id=ff68fa2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff68fa2c",
  null
  
)

export default component.exports